import { EntityComment } from '@app/models';
import { JSONContent } from '@tiptap/core';
import {
  get, post, put, patch, delete_,
} from '@app/utilities/fetchWrapper';

export default {
  list: async function(entityId: string): Promise<Array<EntityComment>> {
    return get(`${COW_API_URL}/comments?entity_id=${entityId}`).then(
      (comments: any) => comments.map((comment: any) => new EntityComment(comment)),
    );
  },
  create: async function(entityId: string, document: JSONContent): Promise<EntityComment> {
    return new EntityComment(await post(
      `${COW_API_URL}/comments`,
      { body: JSON.stringify({ document, entityId }) },
    ));
  },
  update: async function(commentId: string, document: JSONContent): Promise<EntityComment> {
    return put(
      `${COW_API_URL}/comments/${commentId}`,
      { body: JSON.stringify({ document }) },
    ).then((comment: any) => new EntityComment(comment));
  },
  delete: async function(commentId: string): Promise<void> {
    return delete_(
      `${COW_API_URL}/comments/${commentId}`,
    );
  },
  undoDelete: async function(commentId: string): Promise<EntityComment> {
    return new EntityComment(await patch(
      `${COW_API_URL}/comments/deleted/${commentId}`,
      { body: JSON.stringify({ deletedAt: null }) },
    ));
  },
};
